import { AaGetcaptchaResp } from 'app/bff/models/aa/aaGetcaptcha';
import { MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { AaCaptchaVerifyReq } from 'app/bff/models/aa/aaCaptchaVerify';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { Captcha, LoginInfo, MbSigninReq, MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { MbSignoutReq } from 'app/bff/models/mb/mbSignout';
import { ROUTES } from 'app/core/router/paths';
import { MobileLoginProcessStepCodesEnum } from 'app/common/components/Modals/MemberLoginModal/types';

// State type
export interface LoginState {
  static: StaticState;
  mobileLoginProcess: MobileLoginProcessState;
  redirectURL?: ROUTES;
  redirectRouteState?: any;
}

interface StaticState {
  captcha?: AaGetcaptchaResp;
  memberProfile?: MbGetinfoResp;
}

interface MobileLoginProcessState {
  currentStep: MobileLoginProcessStepCodesEnum;
  data?: MbSigninReq;
  otp?: MbSigninResp;
}
// ::: End

// Actions type constant
export const MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP = 'MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP';
export const MEMBER_LOGIN__FETCH_CAPTCHA = 'MEMBER_LOGIN__FETCH_CAPTCHA';
export const MEMBER_LOGIN__FETCH_CAPTCHA_DONE = 'MEMBER_LOGIN__FETCH_CAPTCHA_DONE';
export const MEMBER_LOGIN__FETCH_MEMBER_PROFILE_BY_MOBILE_LOGIN = 'MEMBER_LOGIN__FETCH_MEMBER_PROFILE_BY_MOBILE_LOGIN';
export const MEMBER_LOGIN__BY_PASS_PHRASE_LOGIN = 'MEMBER_LOGIN__BY_PASS_PHRASE_LOGIN';
export const MEMBER_LOGIN__CHECK_CAPTCHA_BY_MOBILE_LOGIN = 'MEMBER_LOGIN__CHECK_CAPTCHA_BY_MOBILE_LOGIN';
export const MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA = 'MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA';
export const MEMBER_LOGIN__SEND_OTP_DONE = 'MEMBER_LOGIN__SEND_OTP_DONE';
export const MEMBER_LOGIN__RESEND_OTP = 'MEMBER_LOGIN__RESEND_OTP';
export const MEMBER_LOGIN__RESEND_OTP_DONE = 'MEMBER_LOGIN__RESEND_OTP_DONE';
export const MEMBER_LOGIN__LOGIN_BY_OTP = 'MEMBER_LOGIN__LOGIN_BY_OTP';
export const MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL = 'MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL';
export const MEMBER_LOGIN__RESET_LOGIN_CACHE = 'MEMBER_LOGIN__RESET_LOGIN_CACHE';
export const MEMBER_LOGIN__SEND_LOGOUT = 'MEMBER_LOGIN__SEND_LOGOUT';
export const MEMBER_LOGIN__CHECK_LAST_TIME_PASSWORD_DATE = 'MEMBER_LOGIN__CHECK_LAST_TIME_PASSWORD_DATE';
// ::: End

// Action creators type
export interface SetMobileLoginCurrentStepAction {
  type: typeof MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP;
  payload: {
    step: MobileLoginProcessStepCodesEnum;
  };
}

export interface FetchCaptchaAction {
  type: typeof MEMBER_LOGIN__FETCH_CAPTCHA;
}

export interface FetchCaptchaDoneAction {
  type: typeof MEMBER_LOGIN__FETCH_CAPTCHA_DONE;
  payload: {
    response: AaGetcaptchaResp;
  };
}

export interface LoginByMobileLoginAction {
  type: typeof MEMBER_LOGIN__FETCH_MEMBER_PROFILE_BY_MOBILE_LOGIN;
  payload: {
    checkCaptchaArgs: AaCaptchaVerifyReq;
    data: LoginInfo;
  };
}

export interface LoginByPassPhraseLoginAction {
  type: typeof MEMBER_LOGIN__BY_PASS_PHRASE_LOGIN;
  payload: {
    checkCaptchaArgs: Captcha;
    authMemberArgs: LoginInfo;
  };
}

export interface SaveMobileLoginDataAction {
  type: typeof MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA;
  payload: {
    data: MbSigninReq;
  };
}

export interface SendOTPDoneAction {
  type: typeof MEMBER_LOGIN__SEND_OTP_DONE;
  payload: {
    response: MbSigninResp;
  };
}

export interface ResendOTPAction {
  type: typeof MEMBER_LOGIN__RESEND_OTP;
  payload: {
    checkCaptchaArgs: Captcha;
    data: LoginInfo;
  };
}

export interface ResendOTPDoneAction {
  type: typeof MEMBER_LOGIN__RESEND_OTP_DONE;
  payload: {
    response: MbSigninResp;
  };
}

export interface LoginByOTPAction {
  type: typeof MEMBER_LOGIN__LOGIN_BY_OTP;
  payload: {
    args: AaOtpVerifyReq;
  };
}

export interface SetLoginRedirectURLAction {
  type: typeof MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL;
  payload: {
    route: ROUTES;
    state?: any;
  };
}

export interface ResetLoginCacheAction {
  type: typeof MEMBER_LOGIN__RESET_LOGIN_CACHE;
}

export interface SendLogoutAction {
  type: typeof MEMBER_LOGIN__SEND_LOGOUT;
  payload: {
    args: MbSignoutReq;
  };
}

export type LoginActions =
    SetMobileLoginCurrentStepAction
  | FetchCaptchaAction
  | FetchCaptchaDoneAction
  | LoginByMobileLoginAction
  | LoginByPassPhraseLoginAction
  | SaveMobileLoginDataAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | LoginByOTPAction
  | SetLoginRedirectURLAction
  | ResetLoginCacheAction
  | SendLogoutAction
// ::: End
